import Image from 'common/components/Image'
import Typography from 'common/components/Typography'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import cdn from 'lib/cdn'
import CurrencyFormatter from 'lib/currency-formatter'
import styled from 'styled-components'

const ItemContainer = styled.a`
  display: flex;
  border-bottom: solid 1px ${theme.colors.grayLighter};
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  flex-shrink: 0;

  &:last-child {
    border-bottom: none;
  }
`

const ItemImageContainer = styled.div`
  width: 48px;
  height: 48px;
`

const ItemImage = styled(Image)`
  border: 1px solid ${theme.colors.grayLightAlt};
`

const ItemContentContainer = styled.div`
  margin-left: 12px;
  width: 100%;
`

const ItemContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  align-items: baseline;
`

/* eslint-disable camelcase */
interface CartItemType {
  id_item: string | number
  default_image: string
  item_name: string
  alias: string
  product_quantity: number
  product_price_subtotal: number
}
/* eslint-enable camelcase */

function CartItem({
  item,
  micrositeUrl,
}: {
  item: CartItemType
  micrositeUrl: string
}): JSX.Element {
  return (
    <ItemContainer
      href={`${WEB_DESKTOP_RALALI_URL}/v/${micrositeUrl}/product/${item.alias}`}
      data-testid="cart-item-container"
    >
      <ItemImageContainer>
        <ItemImage
          width="48px"
          height="48px"
          src={cdn({ path: `/${item.default_image}` })}
          radius="2px"
          objectFit="cover"
        />
      </ItemImageContainer>
      <ItemContentContainer>
        <Typography maxLine={1} type="bparagraph">
          {item.item_name}
        </Typography>
        <ItemContent>
          <Typography type="rsubtitle">{`${item.product_quantity} Barang`}</Typography>
          <Typography type="bh6" color="orange">
            {CurrencyFormatter(item.product_price_subtotal)}
          </Typography>
        </ItemContent>
      </ItemContentContainer>
    </ItemContainer>
  )
}

export default CartItem
